<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <div class="wrap-tab">
          <div class="table-header-gai">
            <el-button
              type="primary"
              size="medium"
              class="cusomer-link-gai"
              @click="openDialog"
              icon="el-icon-paperclip"
              >发布岗位</el-button
            >
          </div>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="24">
              <el-form
                size="medium"
                :inline="true"
                :model="searchCondition"
                class="demo-form-inline"
              >
                <el-form-item label="岗位名称">
                  <el-input
                    v-model="searchCondition.recruit_post"
                    placeholder="请输入岗位名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="时间">
                  <DatePicker @dataSearch="dataSearch" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchButton">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-tabs
            v-model="activeName"
            type="card"
            class="position-tabs"
            @tab-click="handleTabClick"
          >
            <el-tab-pane
              v-for="(item, index) in tabsArr"
              :key="index"
              :name="item.name"
              class="tab-item"
            >
              <span slot="label">{{ item.label }} ({{ item.val }})</span>
            </el-tab-pane>
          </el-tabs>
        </div>
        <ApeTable
          ref="apeTable"
          :data="dataList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column slot="second-column" align="center" label="岗位名称">
            <template slot-scope="scope">
              <div class="text-ellipsis">
                {{ scope.row.recruit_post }}
              </div>
            </template>
          </el-table-column>
          <el-table-column slot="second-column" align="center" label="行业类型">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.recruit_post_category"
                placement="top-start"
                popper-class="ape-table-tooltip"
              >
                <div class="text-ellipsis">
                  {{ scope.row.recruit_post_category }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="报名人数">
            <template slot-scope="scope">
              <div
                style="color:#1890ff;cursor: pointer;"
                @click="goBaoming(scope.row)"
              >
                {{ scope.row.apply_count }}
              </div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <div>{{ status_text[scope.row.show_status] }}</div>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="审核状态" width="100">
            <template slot-scope="scope">
              <span :class="examineStatusClass(scope.row)">{{
                examineStatusText(scope.row)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="分享详情" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="share-detail-entry"
                @click="openShareDetailDialog(scope.row)"
              >
                查看详情
              </el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <span>
                <el-button type="infor" size="mini" @click="toView(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  v-if="scope.row.examine_status == '1'"
                  type="primary"
                  plain
                  size="mini"
                  @click="openQrcodeDialog(scope.row)"
                >
                  二维码
                </el-button>
                <!-- <el-popover placement="top" v-model="scope.row.visible">
                  <p>确定要修改状态吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="checkUpload(scope.row.is_up, scope.row.id)"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    size="mini"
                    :type="scope.row.is_up == 1 ? 'danger' : 'primary'"
                    slot="reference"
                    >{{ scope.row.is_up == 1 ? "关闭" : "开启" }}</el-button
                  >
                </el-popover> -->
              </span>
            </template>
          </el-table-column>
          
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <RecruitQrcodeDialog ref="recruitQrcodeDialog" />
    <RecruitShareDetailDialog ref="recruitShareDetailDialog" />
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import RecruitQrcodeDialog from "@/components/RecruitQrcodeDialog.vue";
import RecruitShareDetailDialog from "@/components/RecruitShareDetailDialog.vue";
import { tog_getSalaryTypeText } from "@/utils/utils";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    RecruitQrcodeDialog,
    RecruitShareDetailDialog,
  },
  data() {
    return {
      activeName: "all",
      tabsArr: [
        {
          label: "全部岗位",
          val: 0,
          name: "all",
        },
        {
          label: "未开始",
          val: 0,
          name: "0",
        },
        {
          label: "进行中",
          val: 0,
          name: "1",
        },
        {
          label: "已完成",
          val: 0,
          name: "2",
        },
        {
          label: "已暂停",
          val: 0,
          name: "3",
        },
      ],
      loadingStaus: false,
      // 搜索条件
      searchCondition: {},
      //任务列表
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      work_text: ["", "全职", "兼职", "实习"],
      columns: [
        {
          title: "用工人数",
          value: "worked_num",
          header_align: "center",
          align: "center",
        },
        {
          title: "年龄要求",
          value: "ageScope",
          header_align: "center",
          align: "center",
        },
        {
          title: "学历要求",
          value: "minimum_education_text",
          header_align: "center",
          align: "center",
        },
        {
          title: "工作地点",
          value: "address_text",
          header_align: "center",
          align: "center",
        },
        {
          title: "薪资范围",
          value: "salaryScope",
          header_align: "center",
          align: "center",
        },
        {
          title: "工作性质",
          value: "workScope",
          header_align: "center",
          align: "center",
        },
        {
          value: "created_at",
          title: "发布时间",
        },
      ],
    };
  },
  computed: {},
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    // 选项卡数量
    async tabNum() {
      // 选项卡数量
      let res_tab = await this.$api.taskListTabNum();
      let {
        all_count,
        not_start_count,
        start_ing_count,
        pause_count,
        end_count,
      } = res_tab;
      this.tabsArr[0].val = all_count;
      this.tabsArr[1].val = not_start_count;
      this.tabsArr[2].val = start_ing_count;
      this.tabsArr[3].val = end_count;
      this.tabsArr[4].val = pause_count;
    },
    /** examine_status：0 待审核 1 审核通过 2 审核拒绝 */
    examineStatusText(row) {
      const v = row.examine_status;
      if (v === 0 || v === "0") return "待审核";
      if (v === 1 || v === "1") return "审核通过";
      if (v === 2 || v === "2") return "审核拒绝";
      return "—";
    },
    examineStatusClass(row) {
      const v = row.examine_status;
      if (v === 0 || v === "0") return "examine-status examine-status--pending";
      if (v === 1 || v === "1") return "examine-status examine-status--pass";
      if (v === 2 || v === "2") return "examine-status examine-status--reject";
      return "examine-status";
    },
    handleTabClick() {
      this.init("search");
    },
    openDialog() {
      this.$router.push({ path: "/position/create" });
    },
    async checkUpload(status, id) {
      var missionStatus;
      if (status == 1) {
        missionStatus = 0;
      }
      if (status == 0) {
        missionStatus = 1;
      }
      let args = {
        is_up: missionStatus,
        // id,
      };
      let res = await this.$api.recruitTaskUpdate(id,args);
      if (res) {
        this.init();
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 初始化
    async init(type) {
      this.loadingStaus = false;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
        this.tabNum();
      }
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { data, pages } = await this.$api.recruitTaskList(searchCondition);
      this.dataList = data.map((item) => {
        item.salaryScope = tog_getSalaryTypeText(item);
        item.ageScope = item.min_age + " - " + item.max_age;
        item.recruit_post_category = item.recruit_post_category.join(",");
        item.workScope = this.work_text[item.work_type];
        return item;
      });
      if (type == "export") {
        return data;
      } else {
        this.dataList = data;
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.outer_trade_no) {
        condition.outer_trade_no = this.searchCondition.outer_trade_no;
      }
      if (this.searchCondition.recruit_post) {
        condition.recruit_post = this.searchCondition.recruit_post;
      }
      if (this.activeName && this.activeName !== "all") {
        condition.status = this.activeName;
      }
      if (this.searchCondition.time_value) {
        condition = {
          ...condition,
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    goBaoming(row) {
      console.log(row);
      this.$router.push({
        path: "/position/registrationList",
        query: { post_id: row.id },
      });
    },
    // 跳转详情页面
    toView(row) {
      this.$router.push({
        path: "/position/create",
        query: { id: row.id },
      });
    },
    openQrcodeDialog(row) {
      if (!row || !row.id) {
        this.$message.warning("未获取到岗位信息");
        return;
      }
      this.$refs.recruitQrcodeDialog.open(row.id);
    },
    openShareDetailDialog(row) {
      this.$refs.recruitShareDetailDialog.open(row);
    },
    // 发布岗位
    addPosition() {
      this.$router.push({ path: "/position/create", params: {} });
    },
  },

  created() {},
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
/* 与私域任务「发布任务」按钮同布局、同尺寸 */
.table-header-gai {
  display: flex;
  gap: 10px;
  height: 35px;
  margin-bottom: 10px;
}

.cusomer-link-gai {
  font-size: 15px;
  width: 160px;
}

.wrap-tab {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}

.position-tabs {
  width: 100%;
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.share-detail-entry {
  color: #1684fc;
  font-weight: 600;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-clamp: 3;
  -webkit-line-clamp: 3;
}

.examine-status {
  font-size: 13px;
  &--pending {
    color: #e6a23c;
  }
  &--pass {
    color: #67c23a;
  }
  &--reject {
    color: #f56c6c;
  }
}
</style>
